<script lang="ts" setup>
import { IconChevronRightThin } from "@packages/icon-library";
import { useLanguage } from "../composables/useLanguage";

defineOptions({ name: "SidebarSelectedLanguage" });

const { currentLanguageLabel } = useLanguage();
</script>

<template>
  <div class="language">
    <p>{{ currentLanguageLabel }}</p>
    <IconChevronRightThin />
  </div>
</template>

<style lang="scss" scoped>
.language {
  display: flex;
  gap: 8px;
  align-items: center;

  > p {
    color: var(--color-semantic-content-normal-tertiary);
    @include body-3-local;
  }

  ::v-deep(.icon) {
    width: 16px;
    height: 16px;
    background-color: var(--color-semantic-content-normal-tertiary);
  }
}
</style>
